import featureFlagsReducer from '@/features/featureFlags/slice';
import authReducer from '@/features/login/slice';
import mfaReducer from '@/features/mfa/slice';
import passwordManagementReducer from '@/features/passwordManagement/slice';
import redirectUrlReducer from '@/features/redirectUrl/slice';
import userRerducer from '@/features/user/slice';

import { combineReducers } from '@reduxjs/toolkit';
import { reducer as flashReducer } from 'redux-flash';

export default combineReducers({
  auth: authReducer,
  featureFlags: featureFlagsReducer,
  mfa: mfaReducer,
  mfaDevices: mfaReducer,
  passwordManagement: passwordManagementReducer,
  redirectUrl: redirectUrlReducer,
  user: userRerducer,
  flash: flashReducer
});
